import type { RejectionCodeInfo, ScenarioInfo, SelectOption } from './console-types'

export const NO_SELECTION = '__NO_SELECTION__'
export const AUTO_SELECTION = '__AUTO_SELECTION__'
export const RANDOM_CODE_SELECTION = '__RANDOM_CODE_SELECTION__'
export const RANDOM_RECEIVER_ACCOUNT_SELECTION = '__RANDOM_RECEIVER_ACCOUNT_SELECTION__'
export const ALL_SELECTION = '__ALL_SELECTION__'
export const DEFAULT_RECEIVER_ACCOUNTS_TEXT = '991199'

export const SCENARIO_INFOS: ScenarioInfo[] = [
  {
    cenario: 'RANDOMICO',
    formaDeIniciacao: 'ALEATORIA',
    descricao: 'Sorteia automaticamente entre todos os cenários disponíveis',
    regras: [
      'Sorteia um cenário concreto a cada geração',
      'Pode resultar em MANU, DICT, DICT_EMAIL, DICT_PHONE, DICT_CPF, DICT_EVP, INIC, QRES ou QRDN',
      'A forma de iniciação efetiva varia conforme o cenário sorteado',
    ],
  },
  {
    cenario: 'MANU',
    formaDeIniciacao: 'MANU',
    descricao: 'Pagamento por dados bancários (entrada manual)',
    regras: [
      'idContaTransacional (chave PIX) deve estar AUSENTE',
      'Dados bancários completos obrigatórios (conta, agência, ISPB)',
      'idConciliacaoRecebedor ausente',
    ],
  },
  {
    cenario: 'DICT',
    formaDeIniciacao: 'DICT',
    descricao: 'Pagamento por chave PIX (tipo aleatório)',
    regras: [
      'idContaTransacional (chave PIX) OBRIGATÓRIO',
      'Conta resolvida a partir do DICT',
      'Dados bancários presentes (resolvidos do diretório)',
    ],
  },
  {
    cenario: 'DICT_EMAIL',
    formaDeIniciacao: 'DICT',
    descricao: 'Pagamento por chave PIX tipo e-mail',
    regras: [
      'idContaTransacional (chave PIX) OBRIGATÓRIO',
      'Conta resolvida a partir do DICT',
      'Dados bancários presentes (resolvidos do diretório)',
    ],
  },
  {
    cenario: 'DICT_PHONE',
    formaDeIniciacao: 'DICT',
    descricao: 'Pagamento por chave PIX tipo telefone',
    regras: [
      'idContaTransacional (chave PIX) OBRIGATÓRIO',
      'Conta resolvida a partir do DICT',
      'Dados bancários presentes (resolvidos do diretório)',
    ],
  },
  {
    cenario: 'DICT_CPF',
    formaDeIniciacao: 'DICT',
    descricao: 'Pagamento por chave PIX tipo CPF',
    regras: [
      'idContaTransacional (chave PIX) OBRIGATÓRIO',
      'Conta resolvida a partir do DICT',
      'Dados bancários presentes (resolvidos do diretório)',
    ],
  },
  {
    cenario: 'DICT_EVP',
    formaDeIniciacao: 'DICT',
    descricao: 'Pagamento por chave PIX tipo aleatória (EVP/UUID)',
    regras: [
      'idContaTransacional (chave PIX) OBRIGATÓRIO',
      'Conta resolvida a partir do DICT',
      'Dados bancários presentes (resolvidos do diretório)',
    ],
  },
  {
    cenario: 'INIC',
    formaDeIniciacao: 'INIC',
    descricao: 'Pagamento iniciado pelo recebedor (iniciador de pagamento)',
    regras: [
      'cnpjIniciadorPagamento OBRIGATÓRIO',
      'idContaTransacional presente (chave do recebedor)',
      'Iniciador de pagamento tem dados completos do recebedor',
    ],
  },
  {
    cenario: 'QRES',
    formaDeIniciacao: 'QRES',
    descricao: 'Pagamento por QR Code estático',
    regras: [
      'idContaTransacional (identificador QR) OBRIGATÓRIO',
      'QR Code estático — valor pode ser definido pelo pagador',
      'idConciliacaoRecebedor ausente',
    ],
  },
  {
    cenario: 'QRDN',
    formaDeIniciacao: 'QRDN',
    descricao: 'Pagamento por QR Code dinâmico',
    regras: [
      'idContaTransacional (identificador QR) OBRIGATÓRIO',
      'idConciliacaoRecebedor (TxId) OBRIGATÓRIO',
      'QR Code dinâmico — valor definido pelo recebedor',
    ],
  },
]

export const REJECTION_CODE_INFOS: RejectionCodeInfo[] = [
  { codigo: 'AB09', descricao: 'Solicitação não suportada' },
  { codigo: 'AC03', descricao: 'Conta do pagador inválida' },
  { codigo: 'AC06', descricao: 'Conta bloqueada' },
  { codigo: 'AC14', descricao: 'Tipo de conta incorreto' },
  { codigo: 'AG03', descricao: 'Transação não suportada' },
  { codigo: 'AG12', descricao: 'Participante inválido' },
  { codigo: 'AM02', descricao: 'Valor não permitido' },
  { codigo: 'AM09', descricao: 'Valor incorreto' },
  { codigo: 'AM12', descricao: 'Valor inválido' },
  { codigo: 'BE01', descricao: 'Inconsistente com dados do cliente' },
  { codigo: 'DS04', descricao: 'Ordem cancelada' },
  { codigo: 'DT02', descricao: 'Data da transação inválida' },
  { codigo: 'FF07', descricao: 'Finalidade inválida' },
  { codigo: 'RC09', descricao: 'Identificação inválida do membro do sistema de compensação' },
  { codigo: 'SL02', descricao: 'Serviço específico oferecido pelo agente credor' },
  { codigo: 'ED05', descricao: 'Liquidação falhou' },
]

export const DEFAULT_SCENARIO = 'RANDOMICO'

export const EXPECTED_RESPONSE_OPTIONS: SelectOption[] = [
  { value: NO_SELECTION, label: 'Nenhuma (manual)' },
  { value: 'ACSP', label: 'ACSP (auto-confirma)' },
  { value: 'RJCT', label: 'RJCT (auto-rejeita)' },
]

export const ACCOUNT_TYPE_OPTIONS: SelectOption[] = [
  { value: AUTO_SELECTION, label: 'Aleatório' },
  { value: 'CACC', label: 'CACC' },
  { value: 'SVGS', label: 'SVGS' },
]

export const RECEIVER_ACCOUNT_TYPE_OPTIONS: SelectOption[] = [
  { value: AUTO_SELECTION, label: 'CACC (padrão)' },
  { value: 'CACC', label: 'CACC' },
  { value: 'SVGS', label: 'SVGS' },
]

export const PURPOSE_OPTIONS: SelectOption[] = [
  { value: AUTO_SELECTION, label: 'IPAY (padrão)' },
  { value: 'IPAY', label: 'IPAY' },
  { value: 'GSCB', label: 'GSCB' },
  { value: 'OTHR', label: 'OTHR' },
]

export const PRIORITY_OPTIONS: SelectOption[] = [
  { value: AUTO_SELECTION, label: 'PAGPRI (padrão)' },
  { value: 'PAGPRI', label: 'PAGPRI' },
]

export const MESSAGE_TYPE_OPTIONS: SelectOption[] = [
  { value: ALL_SELECTION, label: 'Todos os tipos' },
  { value: 'PACS008', label: 'PACS008' },
  { value: 'PACS002', label: 'PACS002' },
  { value: 'PACS004', label: 'PACS004' },
]

export const CONFIG_MODE_OPTIONS: SelectOption[] = [
  { value: 'ACCC', label: 'ACCC (auto-aceita)' },
  { value: 'RJCT', label: 'RJCT (auto-rejeita)' },
  { value: 'MANUAL', label: 'MANUAL (sem resposta automática)' },
]
